import { useState } from "react";
import { Image, Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import Img from '../Img/Contact/Contact-Banner2.jpg';
// import Img from '../Img/Contact/ContactUs Banner.jpg';
import "./Services.css";
import Phone from '../Img/Contact Icons/call.png';
import Mail from '../Img/Contact Icons/mail.png';
import Map from '../Img/Contact Icons/map.png';
// import Whatsapp from '../Img/Contact Icons/whatsapp.png';

function Contact() {
  const [formData, setFormData] = useState({
    companyName: "",
    country: "",
    website: "",
    contactPerson: "",
    phone: "",
    email: "",
    requirement: "",
    query: ""
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { companyName, email, phone } = formData;

    if (!companyName || !email || !phone) {
      alert("Please fill in all required fields.");
      return;
    }

    const body = `
Company Name: ${formData.companyName}
Country: ${formData.country}
Website: ${formData.website}
Contact Person: ${formData.contactPerson}
Phone: ${formData.phone}
Email: ${formData.email}
Requirement: ${formData.requirement}
Query: ${formData.query}
  `;

    window.location.href = `mailto:info@bharatrugagencies.com?subject=Buying Enquiry&body=${encodeURIComponent(
      body
    )}`;
  };

  return (
    <>
      <Image className="fade-in responsive-img" src={Img} height={500} width="100%" fluid />

      <Container>
        <div>
          <h1 className='text-center my-4 text-decoration-underline'><strong>Contact Us</strong></h1>
          {/* <hr style={{ border: '2px', height: '3px', backgroundColor: 'red' }} /> */}
          <Row>
            <Col xs={12} md={6} className='my-3'>
              {/* <p className="justify-text" style={{ textIndent: "7rem", fontSize: "clamp(1rem, 2vw, 2rem)" }}><strong>Bharat Rug Agencies</strong></p> */}

              <h2 className="text-start my-3">Registered Office:</h2>
              <h1>Bharat Rug Agencies</h1>
              <p className="justify-text" style={{ fontSize: "clamp(1rem, 2vw, 1.5rem)" }}>Ramsahaypur, Bhadohi - 221401(U.P.) India</p>

              <p className="" style={{ textIndent: "-3rem", fontSize: "clamp(1rem, 2vw, 1.5rem)" }}>
                <img className='mx-2' src={Phone} alt="Phone Logo" width={30} height={30} />
                <strong  >Mobile-</strong>
                <a href="tel:+919453001175" className="contact-link mx-2">
                  <span style={{ paddingLeft: "1.5rem" }}>+91-945-300-1175</span>
                </a></p>
              {/* <p className="" style={{ textIndent: "-3rem", fontSize: "clamp(1rem, 2vw, 1.5rem)" }}>
                <img className='mx-2' src={Whatsapp} alt="Phone Logo" width={30} height={30} />
                <strong>WhatsApp-</strong>
                <a
                  href="https://wa.me/+917460012246?"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Chat with us on WhatsApp"
                  className="contact-link mx-2"
                >
                  +91-746-001-2246
                </a>
              </p> */}

              <p className="" style={{ textIndent: "-3rem", fontSize: "clamp(0.8rem, 2vw, 1.5rem)" }}>
                <img className='mx-2' src={Mail} alt="Phone Logo" width={30} height={30} />
                <strong>Emails-</strong>
                <a href="mailto:info@bharatrugagencies.com" className="contact-link mx-2">
                  <span style={{ paddingLeft: "1.4rem" }}>info@bharatrugagencies.com</span></a>
                <br />
                <a href="mailto:bharatrugagencies@gmail.com" className="contact-link mx-2">
                  <span style={{ paddingLeft: "7rem" }}>bharatrugagencies@gmail.com</span></a></p>


              <p className="justify-text" style={{ textIndent: "-3rem", fontSize: "clamp(1rem, 2vw, 1.5rem)" }}>
                <img className="mx-2" src={Map} alt="Phone Logo" width={30} height={30} />
                <strong>Branch Office:</strong>
                <br />
                <span> First Floor, Shop No. 49 Bida Mart, Rajpura</span>
                <br />
                <span> Bhadohi - 221401 (U.P.) India</span>
                <br />
                <span>Phone: +91-5414-297556</span>
                {/* <br />
                <span style={{ paddingLeft: "7.4rem" }}> India.</span>                 */}
              </p>

              {/* <p className="py-3" style={{ textIndent: "", fontSize: "clamp(1rem, 2vw, 1.5rem)" }}> */}
              {/* <img className='mx-2' src={Mail} alt="Phone Logo" width={30} height={30} /> */}
              {/* <strong>Email-</strong> */}
              {/* <a href="mailto:bharatrugagencies@gmail.com" className="contact-link mx-2">
                  <span style={{ paddingLeft: "2rem" }}>bharatrugagencies@gmail.com</span></a></p> */}

            </Col>

            {/* FORM */}
            <Col xs={12} md={6} className="my-2">
              <Card className="p-4 shadow-lg"
                style={{
                  minHeight: "460px",
                  borderRadius: "15px"
                }}
              // style={{ border: "3px solid #9e6b0c" }}
              >
                <Card.Body>
                  <Card.Title className="text-start text-danger my-2">
                    <strong><u>Buying Enquiries</u></strong>
                  </Card.Title>

                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Control
                          placeholder="Company Name"
                          name="companyName"
                          value={formData.companyName}
                          onChange={handleChange}
                          required
                          style={{
                            height: "55px",
                            fontSize: "1.05rem",
                            padding: "12px 16px"
                          }}
                        />
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Control
                          placeholder="Country"
                          name="country"
                          value={formData.country}
                          onChange={handleChange}
                          style={{
                            height: "55px",
                            fontSize: "1.05rem",
                            padding: "12px 16px"
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Control
                          placeholder="Website"
                          name="website"
                          value={formData.website}
                          onChange={handleChange}
                          style={{
                            height: "55px",
                            fontSize: "1.05rem",
                            padding: "12px 16px"
                          }}
                        />
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Control
                          placeholder="Contact Person"
                          name="contactPerson"
                          value={formData.contactPerson}
                          onChange={handleChange}
                          style={{
                            height: "55px",
                            fontSize: "1.05rem",
                            padding: "12px 16px"
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Control
                          placeholder="Contact Number"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          style={{
                            height: "55px",
                            fontSize: "1.05rem",
                            padding: "12px 16px"
                          }}
                        />
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Control
                          type="email"
                          placeholder="Email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          style={{
                            height: "55px",
                            fontSize: "1.05rem",
                            padding: "12px 16px"
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Control
                          placeholder="Product / Service Requirement"
                          name="requirement"
                          value={formData.requirement}
                          onChange={handleChange}
                          style={{
                            height: "55px",
                            fontSize: "1.05rem",
                            padding: "12px 16px"
                          }}
                        />
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Control
                          placeholder="Detail of Query"
                          name="query"
                          value={formData.query}
                          onChange={handleChange}
                          style={{
                            height: "55px",
                            fontSize: "1.05rem",
                            padding: "12px 16px"
                          }}
                        />
                      </Col>
                    </Row>

                    {/* <Form.Group className="mb-3">
                    <Form.Control
                      as="textarea"
                      rows={4}
                      placeholder="Your Message *"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group> */}

                    <div className="text-center">
                      <Button
                        type="submit"
                        size="lg"
                        variant="danger"
                        className="hover-black"
                      >
                        Submit
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {/* <p className="text-center" style={{ fontSize: "clamp(1rem, 2vw, 1.5rem)" }}><strong>Every year, we donate at least 2% of our profits to support social services/ initiatives</strong></p> */}

          {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3604.1990524056923!2d82.57163489999999!3d25.3981468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398fde1a1e61a1f1%3A0xf9baf5f56da299b7!2s9HXC%2B6JX%2C%20Bhadohi%20Nagar%20Palika%2C%20Uttar%20Pradesh%20221401!5e0!3m2!1sen!2sin!4v1759130153011!5m2!1sen!2sin"
                    style={{ width: "100%", height: 500 }}
                    title='Map' ></iframe> */}
        </div>
      </Container>
    </>
  )
}

export default Contact